import React from 'react'
import { Box, BoxProps } from 'components/Box'

export const CardGrid: React.FC<BoxProps> = ({ children, ...props }) => {
  return <Box {...props} className="OrdoCardGrid-root" sx={[
    () => ({
      display: 'flex',
      flexWrap: 'wrap',
      // gap: { xs: 0, lg: 1 },
      alignItems: 'stretch',
    }),
    ...(Array.isArray(props.sx) ? props.sx : [props.sx])
  ]}>
    { children }
  </Box>
}

export default CardGrid
